// extracted by mini-css-extract-plugin
export default {"text_div":"Step3_text_div__Ma4SH"};